<template>
  <app-toast
    class="risk-result"
    :message="message"
  >
    <div
      class="toast-body"
      v-html="$t('toast.profile-updated')"
    />
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'RiskResult',

    components: {
      'app-toast': appToast
    },

    props: {
      message: Object
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
</style>
